const cardList = () => import('@/views/main/card/list/list.vue')
export default {
  path: '/main/card/list',
  name: 'cardList',
  component: cardList,
  children: []
}
